/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "precog": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "Product": {
                    "values": {
                      "PRODUCT_UNKNOWN": 0,
                      "PRODUCT_POS": 1,
                      "PRODUCT_TERMINAL": 2,
                      "PRODUCT_VIRTUAL_TERMINAL": 3,
                      "PRODUCT_INVOICES": 4,
                      "PRODUCT_ECOMMERCE": 5,
                      "PRODUCT_APPOINTMENTS": 6,
                      "PRODUCT_RETAIL": 7,
                      "PRODUCT_RESTAURANTS": 8,
                      "PRODUCT_DEVELOPERS": 9,
                      "PRODUCT_PAYROLL": 10,
                      "PRODUCT_GIFT_CARDS": 11,
                      "PRODUCT_CAPITAL": 12,
                      "PRODUCT_CAPITAL_PPP_LOAN": 13,
                      "PRODUCT_ONLINE_CHECKOUT": 14,
                      "PRODUCT_CUSTOMER_DIRECTORY": 15,
                      "PRODUCT_LOYALTY": 16,
                      "PRODUCT_MARKETING": 17,
                      "PRODUCT_TEAM": 18,
                      "PRODUCT_KDS": 19,
                      "PRODUCT_SHIFTS": 20,
                      "PRODUCT_TEAM_COMMUNICATION": 21
                    }
                  },
                  "Subaudience": {
                    "values": {
                      "SUBAUDIENCE_UNKNOWN": 0,
                      "SUBAUDIENCE_COMPLEX_QSR": 1,
                      "SUBAUDIENCE_SIMPLE_QSR": 2,
                      "SUBAUDIENCE_FSR": 3,
                      "SUBAUDIENCE_BAR_BREWERY_LOUNGE": 4,
                      "SUBAUDIENCE_BUSINESS_SERVICE": 5,
                      "SUBAUDIENCE_MAINTENANCE_REPAIR": 6,
                      "SUBAUDIENCE_CONTRACTING_SPECIALTY_TRADE": 7,
                      "SUBAUDIENCE_PERSONAL_SERVICE": 8,
                      "SUBAUDIENCE_CREATIVE_DESIGN": 9,
                      "SUBAUDIENCE_SIMPLE_RETAIL_GOODS": 10,
                      "SUBAUDIENCE_COMPLEX_RETAIL_GOODS": 11,
                      "SUBAUDIENCE_GROCERY_GOURMET_ALCOHOL": 12,
                      "SUBAUDIENCE_BEAUTY": 13,
                      "SUBAUDIENCE_FITNESS": 14,
                      "SUBAUDIENCE_WELLNESS": 15,
                      "SUBAUDIENCE_HEALTHCARE": 16,
                      "SUBAUDIENCE_LEISURE_ENTERTAINMENT": 17,
                      "SUBAUDIENCE_TRANSPORTATION": 18,
                      "SUBAUDIENCE_CASUAL_USE": 19,
                      "SUBAUDIENCE_CHARITY_EDUCATION_MEMBERSHIP": 20
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.Product && !$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.Subaudience) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Product @ squareup/precog/v2/common.proto at 8:1
 */
export const Product = $root.lookupEnum('squareup.precog.api.v2.Product').values;
/**
 * Subaudience (one word!) is a grouping of sellers based on their business subcategory or catalog item type.
 * This may be modified in the future to be a more general grouping of sellers based on their business needs.
 * This list is the source of truth for the subaudiences in Square ecosystem.
 *
 * SOURCE Subaudience @ squareup/precog/v2/common.proto at 36:1
 */
export const Subaudience = $root.lookupEnum('squareup.precog.api.v2.Subaudience').values;